/** Deep link to account plan / usage (scroll target on billing settings page). */
export const PLAN_BILLING_USAGE_SECTION_ID = "usage" as const

/** Plan comparison / upgrade CTAs (post-checkout cancel scroll target). */
export const PLAN_BILLING_COMPARE_SECTION_ID = "plans" as const

export function planBillingManageHref(): string {
  return `/settings/billing#${PLAN_BILLING_USAGE_SECTION_ID}`
}

/** Stripe Checkout success — return to Plan & billing with usage in view. */
export function planBillingCheckoutSuccessPath(): string {
  return `/settings/billing?checkout=success#${PLAN_BILLING_USAGE_SECTION_ID}`
}

/** Stripe Checkout cancel — stay on Plan & billing near plan choice. */
export function planBillingCheckoutCancelPath(): string {
  return `/settings/billing?checkout=cancel#${PLAN_BILLING_COMPARE_SECTION_ID}`
}
